import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-component-history',
  templateUrl: './component-history.component.html',
  styleUrls: ['./component-history.component.css']
})
export class ComponentHistoryComponent implements OnInit {
  queryParamsLogin: any = {};
  shopifyDomain: string = '';
  responseData: any[] = [];
  responseMessage: string = '';
  isLoading: boolean = false;
  parsedComponents: any[] = [];
  selectedVersion: number | string = '';

  constructor(private apiService: ApiService) {
    const token = JSON.parse(localStorage.getItem('token'));
    this.queryParamsLogin = token;
  }

  ngOnInit(): void {}

  // Fetch component history for entered domain
  fetchHistory(): void {
    if (!this.shopifyDomain || !this.shopifyDomain.trim()) {
      alert('Please enter a shopify domain');
      return;
    }

    this.isLoading = true;
    this.responseMessage = '';
    this.responseData = [];
    this.parsedComponents = [];
    this.selectedVersion = '';

    this.apiService.getComponentHistory(this.shopifyDomain.trim()).subscribe(
      (response) => {
        this.isLoading = false;
        console.log('getComponentHistory response:', response);
        const records = Array.isArray(response) ? response : (response && response.length !== undefined ? response : []);

        if (records.length > 0) {
          // 1. Sort ascending by createdAt to assign accurate chronological version numbers (v1 = earliest)
          records.sort((a: any, b: any) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
          records.forEach((record: any, index: number) => {
            record.versionNumber = index + 1;
          });

          // 2. Order records newest first so the latest version is at the top
          records.sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
          this.responseData = records;
          this.responseMessage = `Retrieved ${this.responseData.length} component history record(s) for domain ${this.shopifyDomain}`;
        } else {
          this.responseData = [];
          this.responseMessage = `No component history records found for domain ${this.shopifyDomain}`;
        }
      },
      (error) => {
        this.isLoading = false;
        console.error('getComponentHistory error:', error);
        this.responseMessage = 'Error: Unable to fetch component history.';
      }
    );
  }

  // Parse components and show each with collapsible arrow
  viewRecordData(record: any): void {
    this.selectedVersion = record.versionNumber || '';
    try {
      const parsed = typeof record.data === 'string' ? JSON.parse(record.data) : record.data;
      this.parsedComponents = Array.isArray(parsed)
        ? parsed
        : (Array.isArray(parsed?.components) ? parsed.components : [parsed]);
    } catch (e) {
      this.parsedComponents = [{ raw: record.data }];
    }
  }

  closePreview(): void {
    this.parsedComponents = [];
    this.selectedVersion = '';
  }

  reloadHome(): void {
    window.location.href = '/';
  }
}
